var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote-message",on:{"click":_vm.gotoReply}},[_c('div',{staticClass:"author"},[_vm._v("\n        "+_vm._s(_vm.getAuthor())+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.getText())}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ec3c42","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/popup-chat/messages/QuoteMessage.vue
// module id = I7ol
// module chunks = 0